import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { NotificationListDetailsService } from './notification-list-details.service';
@Component({
  selector: 'app-notification-list-details',
  templateUrl: './notification-list-details.component.html',
  styleUrls: ['./notification-list-details.component.scss']
})
export class NotificationListDetailsComponent implements OnInit {
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  displayedColumns: string[] = [
    "date",
    "first_name",
    "email",
    "phone",
    "status",
    "current_stage.stage",
    'lead_type',
    'type',
    "action",
  ];
  private subscription!: Subscription;
  key:any = ''
  constructor(public dialog: MatDialog, private notificationListDetailsService: NotificationListDetailsService) {
    this.subscription = this.notificationListDetailsService.currentData.subscribe((res: any) => {
      if (res) {
        this.key = res;
        this.pageNumber = 1;
        this.pageLimit = 10;
        this.getToDoList();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
  }

  getToDoList() {
    let request: any = {
      "key": this.key,
      "page": this.pageNumber,
      "limit": this.pageLimit
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.notificationListDetailsService.getToDoList(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data.leads
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        setTimeout(() => {
          this.paginator.length = responseData?.data?.totalItems
          this.paginator.pageIndex = this.pageNumber - 1
        }, 100)
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  pageNumber: any = 1
  pageLimit: any = 10
  pageHandler(event: any) {
    this.pageLimit = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.getToDoList();
  }

  onPanelToggle(event: any) {
    if (!event) {
      this.getToDoList();
    }
  }
}
